import { useMutation } from "@apollo/client";

import {
  DeleteSKUMutation,
  DeleteSKUMutationVariables,
} from "../../../../../API";
import { DELETE_SKU } from "../../../../../common/operations/mutations";
import { successNotification } from "../../../../../common/variables/notification";
import { handleApolloError } from "../../../../../common/utils/handleApolloError";

export const useDeleteSKU = () => {
  const [saveSKU, { data, loading }] = useMutation<
    DeleteSKUMutation,
    DeleteSKUMutationVariables
  >(DELETE_SKU);

  const deleteSKU = async (id: string) => {
    return await saveSKU({
      variables: {
        id,
      },
      onCompleted: response => {
        if (response.deleteSKU) {
          successNotification("SKU deleted successfully");
        }
      },
      onError: handleApolloError,
      update(cache) {
        const normalizedId = cache.identify({
          id,
          __typename: "SKU",
        });

        cache.evict({ id: normalizedId });

        cache.gc();
      },
    });
  };

  return { deleteSKU, data, loading };
};
